import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '11px',
    borderRadius: '100rem',
    boxSizing: 'border-box',
    padding: '4px 16px',
    background: 'linear-gradient(272.76deg, #D724E7 0%, #FF4DDE 100%)',
    color: 'white',
    cursor: 'pointer',
    userSelect: 'none'
  },

  icon: {
    marginLeft: '10px',
    height: '1rem',
    width: '1rem'
  }
}))

export default useStyles
